import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import  { getAgentConfig }from "@/utils/common"
// import  { wxAgentConfig }from "@/api/wenxin"
import echarts from "./utils/echartsUI.js";
import * as ww  from '@wecom/jssdk'
// const wx = require('./wx.js')
Vue.prototype.$echarts = echarts;
import axios from "axios";
Vue.prototype.$http = axios;
Vue.prototype.$ww  = ww ;
import { analysisJWT } from "./api/loginuserinfo/loginuserinfo.js"; 
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import {Message} from 'element-ui'
Vue.use(ElementUI);
// let arr = []
// let count = 0
// Vue.prototype.$message = (options) => {
//   arr.push(options)
//   count++
//   const complete = () => {
//     const {onClose, ...otherOptions} = options
//     count --
//     if(count<3) {
//       // let  arr.pop()
//       Message({...otherOptions,onClose:complete})
//       onClose && onClose()
//     }
//   }
//   Message({...options,onClose:complete})
// }
import VueDirectiveImagePreviewer from "vue-directive-image-previewer";
import "vue-directive-image-previewer/dist/assets/style.css";
Vue.use(VueDirectiveImagePreviewer, {
  background: {
    // or : background: '#000'
    color: "#000", // or rgba or rgb     // or image: 'url(xxx)'
  },
  // transition
  animate: {
    duration: 300,
    delay: 50,
  },
  // loading (not supported)
  loading: {
    image:
      "http://172.16.0.250:8080/enterprisewx-miniprogram/enterprisewx/images/1624428602863.jpg",
  },
  // cursor(css)
  cursor: "pointer",
  clickMethod: "doubleClick", // click or doubleClick(not supported)
});

// 引入查看大图插件
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";


Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    inline: false,
    button: false, // 显示右上角关闭按钮
    navbar: false, // 缩略图导航
    title: false, // 是否显示当前图片的标题
    toolbar: false, // 显示工具栏
    tooltip: true, // 显示缩放百分比
    movable: true, // 图片是否可移动
    zoomabl: true, // 是否可缩放
    rotatable: false, // 是否可旋转
    scalable: false, // 是否可翻转
    transition: true, // 是否使用 CSS3 过度
    fullscreen: false, // 播放时是否全屏
    keyboard: true, // 是否支持键盘
    // url: 'data-source' // 设置大图片的 url
  },
});
import { download } from "@/utils/request";
import audio from "vue-mobile-audio";
Vue.use(audio);
import VueAudio from "vue-audio-better";
Vue.use(VueAudio);
import AudioVisual from "vue-audio-visual";
Vue.use(AudioVisual);
import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
Vue.use(VXETable);

import NProgress from "nprogress"; //引入nprogress
import "nprogress/nprogress.css"; //这个样式必须引入

import ElTableBar from "el-table-bar-base";
import "el-table-bar-base/lib/ElTableBar.css";
Vue.use(ElTableBar);

import moment from "moment";
Vue.prototype.$moment = moment; // 日期格式化


import domainNameConfig from "@/domainNameConfig";
Vue.prototype.$baseUrl = domainNameConfig;

Vue.prototype.download = download;

import Pagination from "./components/page/Pagination";
Vue.component(Pagination.name, Pagination);

Vue.config.productionTip = false;

var explorer = navigator.userAgent; //浏览器类型
if (explorer.indexOf("QQBrowser") <= 0) {
  //判断是不是企业微信自带的浏览器

  NProgress.inc(0.2); //加载进度条的粗度
  NProgress.configure({ easing: "ease", speed: 500, showSpinner: false }); //加载进度条的加载速度
  const routeList = ["Login", "Page403"];
  router.beforeEach(function(to, from, next) {
    NProgress.start();
    //判断当前路径名是不是Login，如果是则判断存储在localStorage中的token是否存在，如果存在再根据token
    //去访问后端接口，如果token过期/token无效/签名无效跳转到/login,否则跳转到/index。（此用法用于：例如：在浏览器中输入
    //'http://172.16.0.220:8092/myvue/customer/Eamc'，如果token过期/token无效/签名无效则跳转到'/login'，否则跳转到以上链接路径'http://172.16.0.220:8092/myvue/customer/Eamc'）
    if (to.name === "Login") {
      //当前路径名是'Login'，
      if (
        to.query.mark === "error" ||
        to.query.mark === "invalid" ||
        to.query.mark === "noLicense" ||
        to.query.mark === "nopermit"
      ) {
        const list = {
          error: {
            message: "你所在的企业尚未安装客莱宝，无法正常登录!",
            type: "error",
            customClass: "",
          },
          invalid: {
            message: "服务已到期，请联系客莱宝平台人员续期后使用！",
            type: "error",
            customClass: "",
          },
          noLicense: {
            message: "暂无账号使用权限，请联系企业管理员为你开通!",
            type: "info",
            customClass: "info-message",
          },
          nopermit: {
            message: "暂无后台登录权限，请联系企业管理员为你开通!",
            type: "info",
            customClass: "info-message",
          },
        };
        Vue.prototype.$message.error({
          message: list[to.query.mark].message,
          // type: list[to.query.mark].type,
          type: 'error',
          offset: 30,
          customClass: list[to.query.mark].customClass,
          duration: 5000,
        });
        next({
          path: "/login",
        });
      } else {
        if (localStorage.getItem("Authorization") != null) {
          analysisJWT(localStorage.getItem("Authorization")).then((res) => {
            if (res.error.code == 200) {
              next({ path: res.data.staffRoleUrl[0] });
            } else {
              next({ path: "/login" });
            }
          });
    
        } else {
          if (to.name == "Login") {
            next();
          } else {
            if (from.name === "Index") {
              next({
                path: "/login",
              });
            } else {
              next();
            }
          }
        }
      }
    } else {
      if (to.query.token != undefined && to.query.token != null) {
        console.log("to.query.token+++++",to.query.token);
        localStorage.setItem("Authorization", to.query.token);
        // await getSessionVersion(localStorage.getItem("Authorization")).then((res) => {
        //   if (res && res.error && res.error.code === 200) {
        //     this.isNewEdition = res.data
        //     console.log("dsfsdfsfsdf1111",this.isNewEdition);
        //     window.localStorage.setItem("isNewEdition", this.isNewEdition);
        //   } else {
        //     // this.$message.error("获取版本参数失败")
        //   }
        // }).catch((err) => {
        //   // this.$message.error("获取版本参数失败")
        //   console.log("新旧版本参数获取失败", err);
        // });
        getAgentConfig(to.query.token)
        Vue.prototype.$notify({
          title: "登录成功",
          message: "欢迎使用客莱宝后台",
          type: "success",
          offset: 40,
          duration: 6000,
        });
        
        next({ path: to.path });
      } else if (to.name == "Page403") {
        next();
      } else {
        //如果/index路径中没有携带token参数，则获取到存储在localStorage中的token，再根据这个token去判断是否token过期/token无效/签名无效
        if (localStorage.getItem("Authorization") != null) {
          analysisJWT(localStorage.getItem("Authorization")).then((res) => {
            //token过期/token无效/签名无效
            if (res.error.code != 200) {
              Vue.prototype.$message({
                message: "登录状态已过期，请重新登录！",
                type: "error",
                offset: 30,
                duration: 4000,
              });
              localStorage.removeItem("Authorization");
              localStorage.removeItem("url");
              localStorage.removeItem("routerList");
              localStorage.removeItem("myDepartment");
              localStorage.removeItem("userId");
              next({
                path: "/login",
              });
            } else {
              // token有效/签名有效
              localStorage.setItem("url", res.data.staffRoleUrl);
              if (localStorage.getItem("url") != null) {
                var str = localStorage.getItem("url").split(",");
                if (str.indexOf(to.fullPath) != -1) {
                  next();
                } else {
                  next({
                    path: "/page403",
                  });
                }
              } else {
                next({
                  path: "/page403",
                });
              }
            }
          });
        } else {
          next({
            path: "/login",
          });
        }
      }
    }
  });
  router.afterEach(() => {
    NProgress.done();
  });
}else{
  console.log("有没有进来1！！！！");

}
// console.log("有没有进来！！！！",localStorage.getItem("Authorization"));
// getAgentConfig()

// alert(ex)

new Vue({
  router,
  store,
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue(),
  },
  render: (h) => h(App),
}).$mount("#app");

console.log('当前环境变量:', process.env)
